module.exports = __webpack_public_path__ + "static/media/26UNRWA22.014a86e4.jpg";